const tr = {
  partner:{
    attributes:{
      id:                   'Id',
      name:                 'Nome',
      code:                 'Código',
      doctor:               'Desconto Médico',
      api_token:            'Token',
      type:                 'Tipo',
      created_at:           'Criado em',
      updated_at:           'Atualizado em',
      supplier:             'Parceiro',
      promo:                'Promoção',
      corporation:          'Empresa'
    },
    extras:{
      create_partner: 'Novo parceiro',
      edit_partner: 'Editando parceiro',
      show_partner: 'Visualizando parceiro',
      delete_partner: 'Excluir parceiro',
      copy_token: 'Copiar Token',
      copy_token_success: 'Token copiado para área de transferência!',
      copy_token_fail: 'Não foi possível copiar o Token'
    },
    defSingular: 'Parceiro',
    defPlural: 'Parceiros',
  }
};

export default tr;
